<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位调查情况" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" @click="onCancel">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-spin :spinning="loading">
                    <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 10 }" style="padding:10px 20px;">
                        <FGCollapsiblePanel title="单位及咨询师就业情况调查表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="登记表编号">
                                        <a-input ref="djbbh" v-model="editData.djbbh" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="登记日期">
                                        <a-input ref="djrq" v-model="editData.djrq" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="单位名称">
                                        <a-input ref="dwmc" v-model="editData.dwmc" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师人数">
                                        <a-input-number ref="zxsrs" v-model="editData.zxsrs" style="width:100%" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师流动性">
                                        <a-input ref="zxsldx" v-model="editData.zxsldx" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(18年)">
                                        <a-input ref="zxsxzqk18" v-model="editData.zxsxzqk18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(19年)">
                                        <a-input ref="zxsxzqk19" v-model="editData.zxsxzqk19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询师新增情况(20年)">
                                        <a-input ref="zxsxzqk20" v-model="editData.zxsxzqk20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="新增人数(18年)">
                                        <a-input-number ref="zxsxzrs18" v-model="editData.zxsxzrs18" style="width:100%" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="新增人数(19年)">
                                        <a-input-number ref="zxsxzrs19" v-model="editData.zxsxzrs19" style="width:100%" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="新增人数(20年)">
                                        <a-input-number ref="zxsxzrs20" v-model="editData.zxsxzrs20" style="width:100%" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询业资信评价证书等级">
                                        <FGDictSelectCN dictNo="HY200203" v-model="editData.zxpjzsdj" placeholder="" mode="multiple" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(18年)">
                                        <a-input-number
                                            ref="cjpxrsbl18"
                                            v-model="editData.cjpxrsbl18"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(19年)">
                                        <a-input-number
                                            ref="cjpxrsbl19"
                                            v-model="editData.cjpxrsbl19"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="参加培训人次数占职工人数比例(20年)">
                                        <a-input-number
                                            ref="cjpxrsbl20"
                                            v-model="editData.cjpxrsbl20"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="是否还参加其他职业培训(除规定学时外)">
                                        <FGDictSelectCN dictNo="HY200204" v-model="editData.sfcjqtpx" placeholder="" mode="multiple" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(18年)">
                                        <a-input-number
                                            ref="qyzyzyzrsbl18"
                                            v-model="editData.qyzyzyzrsbl18"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(19年)">
                                        <a-input-number
                                            ref="qyzyzyzrsbl19"
                                            v-model="editData.qyzyzyzrsbl19"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="启用执业专用章人数占比(20年)">
                                        <a-input-number
                                            ref="qyzyzyzrsbl20"
                                            v-model="editData.qyzyzyzrsbl20"
                                            style="width:100%"
                                            :precision="2"
                                            disabled
                                            class="view"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="咨询人员配备占达标比例">
                                        <a-input ref="zxrypbzdbbl" v-model="editData.zxrypbzdbbl" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="18年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.qybbzqk18" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="19年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.qybbzqk19" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="20年企业被表彰情况(政府机构、行业等)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.qybbzqk20" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="业务合约执行情况表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(18年)">
                                        <a-input ref="htzxjfmyd18" v-model="editData.htzxjfmyd18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(18年)">
                                        <a-input ref="htzxjfbmyyy18" v-model="editData.htzxjfbmyyy18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(19年)">
                                        <a-input ref="htzxjfmyd19" v-model="editData.htzxjfmyd19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(19年)">
                                        <a-input ref="htzxjfbmyyy19" v-model="editData.htzxjfbmyyy19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同执行甲方满意度(20年)">
                                        <a-input ref="htzxjfmyd20" v-model="editData.htzxjfmyd20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="不满意原因(20年)">
                                        <a-input ref="htzxjfbmyyy20" v-model="editData.htzxjfbmyyy20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(18年)">
                                        <a-input ref="htwzxhbdwqk18" v-model="editData.htwzxhbdwqk18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(18年)">
                                        <a-input ref="zyyy18" v-model="editData.zyyy18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(18年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.yycs18" :rows="1" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(19年)">
                                        <a-input ref="htwzxhbdwqk19" v-model="editData.htwzxhbdwqk19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(19年)">
                                        <a-input ref="zyyy19" v-model="editData.zyyy19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(19年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.yycs19" :rows="1" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="合同未执行或不到位情况(20年)">
                                        <a-input ref="htwzxhbdwqk20" v-model="editData.htwzxhbdwqk20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="主要原因(20年)">
                                        <a-input ref="zyyy20" v-model="editData.zyyy20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="原因阐述(20年)" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.yycs20" :rows="1" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="质量保障体系建设情况">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="项目接收或投标前有无相关标准、制度、规范等">
                                        <a-input ref="xmjstbqbzbj" v-model="editData.xmjstbqbzbj" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmjstbqbz" v-model="editData.xmjstbqbz" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="项目执行(事中)有无相关标准、制度、规范等">
                                        <a-input ref="xmzxbzbj" v-model="editData.xmzxbzbj" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmzxbz" v-model="editData.xmzxbz" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="项目完成后(事后)有无相关标准、制度、规范等">
                                        <a-input ref="xmwcbzbj" v-model="editData.xmwcbzbj" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="xmwcbz" v-model="editData.xmwcbz" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="其他有无相关标准、制度、规范等">
                                        <a-input ref="qtbzbj" v-model="editData.qtbzbj" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="如有，列出相关标准、制度、规范名称">
                                        <a-input ref="qtbz" v-model="editData.qtbz" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="企业发展面临的主要问题">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="行业发展与市场存在问题">
                                        <a-input ref="hyfzyscczwt" v-model="editData.hyfzyscczwt" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.hyfzyscdxsl" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.hyfzyscjy" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="人力资源、单位资信等存在问题">
                                        <a-input ref="rlzyczwt" v-model="editData.rlzyczwt" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.rlzydxsl" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.rlzyjy" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业不正当竞争和地方保护等主要问题存在问题">
                                        <a-input ref="hybzdjzczwt" v-model="editData.hybzdjzczwt" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.hybzdjzdxsl" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.hybzdjzjy" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="其他存在问题">
                                        <a-input ref="qtczwt" v-model="editData.qtczwt" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="典型事例描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.qtdxsl" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对策与建议" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.qtjy" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                        <FGCollapsiblePanel title="协会工作评价表">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(18年)">
                                        <a-input ref="hygfyz18" v-model="editData.hygfyz18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(19年)">
                                        <a-input ref="hygfyz19" v-model="editData.hygfyz19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="行业规范运作(20年)">
                                        <a-input ref="hygfyz20" v-model="editData.hygfyz20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="行业规范运作建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.hygfyzjyyyq" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(18年)">
                                        <a-input ref="zzpxywzd18" v-model="editData.zzpxywzd18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(19年)">
                                        <a-input ref="zzpxywzd19" v-model="editData.zzpxywzd19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="组织培训与业务指导(20年)">
                                        <a-input ref="zzpxywzd20" v-model="editData.zzpxywzd20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="组织培训与业务指导建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.zzpxywzdjyyyq" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(18年)">
                                        <a-input ref="ljfysq18" v-model="editData.ljfysq18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(19年)">
                                        <a-input ref="ljfysq19" v-model="editData.ljfysq19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="了解与反映诉求(20年)">
                                        <a-input ref="ljfysq20" v-model="editData.ljfysq20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="了解与反映诉求建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.ljfysqjyyyq" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(18年)">
                                        <a-input ref="xhfwnlts18" v-model="editData.xhfwnlts18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(19年)">
                                        <a-input ref="xhfwnlts19" v-model="editData.xhfwnlts19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="协会服务能力提升(20年)">
                                        <a-input ref="xhfwnlts20" v-model="editData.xhfwnlts20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="协会服务能力提升建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.xhfwnltsjyyyq" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(18年)">
                                        <a-input ref="gzpj18" v-model="editData.gzpj18" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(19年)">
                                        <a-input ref="gzpj19" v-model="editData.gzpj19" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="请您对协会总体工作给予评价(20年)">
                                        <a-input ref="gzpj20" v-model="editData.gzpj20" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="对协会总体工作评价建议与要求" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.gzpjjyyyq" :rows="2" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入部门">
                                        <a-input ref="bmmc" v-model="editData.bmmc" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入人">
                                        <a-input ref="lrr" v-model="editData.lrr" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="录入时间">
                                        <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="12">
                                    <a-form-item label=" 请围绕配合政府部门监督、配合行业及社会监督以及" :label-col="{ span: 20 }" :colon="false">
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="24">
                                    <a-form-item label="履行社会责任三方面来谈谈企业近三年的工作情况" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                                        <a-textarea v-model="editData.gzqk" :rows="3" disabled class="view" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </FGCollapsiblePanel>
                    </a-form>
                </a-spin>
                <!-- 操作日志 -->
                <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
export default {
    name: "DwdcqkdjForm",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        subTitle() {
            return "查看";
        }, // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/dwdc/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.editData.zxpjzsdj = data.data.zxpjzsdj.split(",");
                            this.editData.sfcjqtpx = data.data.sfcjqtpx.split(",");
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        //撤销操作
        onCancel(type) {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.loading = true;
                    this.$FG_http
                        .post("./api/main/hydcgl/dwdc/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 设置当前行
                                this.lookDataId = this.editData.id;
                                // 返回列表
                                this.formIsVisible = false;
                            }
                        });
                }
            });
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style lang="scss" scoped></style>
